import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from "angular-datatables";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select2Module } from 'ng-select2-component';
import { HighchartsChartModule } from 'highcharts-angular';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { MenuComponent } from './menu/menu.component';
import { ModalTemplatesComponent } from './modal-templates/modal-templates.component';
import { OnlyDigitsPipe } from '../../pipes/onlyDigits';



@NgModule({
  declarations: [
    LanguageSelectorComponent,
    ModalTemplatesComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    Select2Module,
    HighchartsChartModule,
    TranslateModule.forChild(),
    OnlyDigitsPipe
  ],
  exports: [
    TranslateModule,
    LanguageSelectorComponent,
    ModalTemplatesComponent,
    OnlyDigitsPipe
  ],
  providers: [
    DecimalPipe
  ]
})
export class SharedModule { }
